import React from 'react';
import { DatePickerProps } from 'antd';
import { DatePickerPopupStyle, StyledDatePicker } from './styles';

const DatePicker: React.FC<DatePickerProps> = (props) => {
    return (
        <>
            <DatePickerPopupStyle />
            <StyledDatePicker popupClassName="custom-date-picker-popup" {...props} />
        </>
    );
};

export default DatePicker;
